import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a6b8dca4")

_pushScopeId("data-v-a6b8dca4")
const _hoisted_1 = {
  class: "fish-list-item",
  "data-test": "fishListItem"
}
const _hoisted_2 = { class: "fish" }
const _hoisted_3 = { class: "fish__name" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "fish__edit" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-angle-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['status', _ctx.statusStyle]
    }, null, 2),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.fish.name), 1),
      _hoisted_4
    ])
  ]))
})